import { NetworkService } from '../../../../services/networkService';
import tenantUtils from '@utils';

const fetchTrubrokerAgentDetails = async () => {
  const response = await NetworkService.get('/api/users/trubroker/leader_board');
  if (response) {
    if (response?.error) {
      return response;
    }
    return {
      list: response?.data?.users?.map((e) => {
        return {
          ...e,
          rank_details: e?.rank ? e?.rank + 'th' : '-',

          agent_details: {
            name: tenantUtils.getLocalisedString(e, 'name'),
            user_agency_name: tenantUtils.getLocalisedString(e?.agency, 'name'),
            image: e?.profile_image,
          },
          tru_points: e?.score ? e?.score : '-',
        };
      }),

      table: [
        {
          title: 'Position',
          dataIndex: 'rank_details',
          key: 'rank_details',
          component: 'String',
        },

        {
          title: 'Name',
          dataIndex: 'agent_details',
          key: 'agent_details',
          component: 'StaffDetails',
        },
        {
          title: 'TruPoints™',
          dataIndex: 'tru_points',
          key: 'tru_points',
          component: 'String',
        },
      ],
    };
  }
};

export default fetchTrubrokerAgentDetails;
